import { Component, Input, Output, OnChanges, SimpleChanges, SimpleChange, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs/Rx';

@Component({
    selector: 'confirmation-dialog',
	templateUrl: './confirmation-dialog.component.html',
	styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnChanges {

	@Input() display: boolean = false;
	@Input() message: string = "";
	@Output() onYes = new EventEmitter();
	@Output() onNo = new EventEmitter();

	constructor() {
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes["display"]) {
		}
	}

	public onDialogHide(): void {
		this.onNoClicked();
	}

	public onYesClicked(): void {
		this.onYes.emit(true);
    }

	public onNoClicked(): void {
		this.onNo.emit(true);
	}
}
